import { render, staticRenderFns } from "./MainMenuHeaderItem.vue?vue&type=template&id=3bf52d44&scoped=true&"
import script from "./MainMenuHeaderItem.vue?vue&type=script&lang=js&"
export * from "./MainMenuHeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuHeaderItem.vue?vue&type=style&index=0&id=3bf52d44&scoped=true&lang=less&"
import style1 from "./MainMenuHeaderItem.vue?vue&type=style&index=1&id=3bf52d44&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf52d44",
  null
  
)

export default component.exports